import { CardString, Rank, Suit } from '@repo/database/src/types';

export interface ICard {
  rank: Rank;
  suit: Suit;
}

export const toRank = (value: string | Rank): Rank =>
  Object.values(Rank).includes(value as Rank) ? (value as Rank) : Rank.UNKNOWN;

export const toSuit = (value: string | Suit): Suit =>
  Object.values(Suit).includes(value as Suit) ? (value as Suit) : Suit.UNKNOWN;

export const makeCard = (rank: Rank, suit: Suit): ICard => ({ rank, suit });

export const unknownCard = { rank: Rank.UNKNOWN, suit: Suit.UNKNOWN };

export const cardToString = (card: ICard): CardString => `${card.rank}${card.suit}`;
